import { ChangeBeneficiaries } from './components/ChangeBeneficiaries';
import { PrivatePensionList } from './components/PrivatePensionList';
import { SecondCopy } from './components/SecondCopy';

export interface PrivatePensionContractedTabProps {
  setSelectedTab: (tab: PrivatePensionContactedAvailableTabs) => void;
}

export const privatePensionContactedTabs = {
  list: {
    component: PrivatePensionList,
  },
  secondCopy: {
    component: SecondCopy,
  },
  changeBeneficiaries: {
    component: ChangeBeneficiaries,
  },
};

export type PrivatePensionContactedAvailableTabs = keyof typeof privatePensionContactedTabs;
export type PrivatePensionContactedTabDefinition = { label: string; component: JSX.Element };

export const PrivatePensionContactedTabsKeys = Object.keys(privatePensionContactedTabs);
export const PrivatePensionContactedInitialTab =
  PrivatePensionContactedTabsKeys[0] as PrivatePensionContactedAvailableTabs;
